import { render, staticRenderFns } from "./dashboard-chart-vertical.vue?vue&type=template&id=041dd400&scoped=true&"
import script from "./dashboard-chart-vertical.vue?vue&type=script&lang=js&"
export * from "./dashboard-chart-vertical.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-chart-vertical.vue?vue&type=style&index=0&id=041dd400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041dd400",
  null
  
)

export default component.exports